import {
  Box,
  Link,
  List,
  ListItem,
  ListItemText,
  SxProps,
  Typography
} from '@mui/material';
import { Button } from 'system/atoms';
import { BackButton } from 'components/Buttons';
import { getSupportUrl } from 'core/utils/supportUrl';
import { META_BUSINESS_ACCOUNT_URL } from '../constants';
import LaunchIcon from '@mui/icons-material/Launch';

type Props = {
  handleNext: (step: number) => void;
  handleBack: () => void;
};

const listItemStyle: SxProps = {
  display: 'list-item'
};

export const SetupWhatsAppBusinessAccountStep: React.FC<Props> = ({
  handleNext
}) => {
  return (
    <Box>
      <BackButton onClick={() => handleNext(0)} />
      <Typography variant="h6" mt={3}>
        What next?
      </Typography>
      <List sx={{ listStyle: 'decimal' }} disablePadding>
        <ListItem>
          <ListItemText
            primary={
              <Typography>
                Create a{' '}
                <Link href={META_BUSINESS_ACCOUNT_URL} target="_blank">
                  Create a Meta Business account
                </Link>
              </Typography>
            }
            sx={listItemStyle}
          />
        </ListItem>

        <ListItem>
          <ListItemText
            primary={
              <Typography>
                Purchase a mobile number to use or{' '}
                <Link
                  href={getSupportUrl({
                    ticketForm: 'purchase_a_mobile_number'
                  })}
                  target="_blank"
                >
                  ask Popp's support team
                </Link>
              </Typography>
            }
            sx={listItemStyle}
          />
        </ListItem>

        <ListItem>
          <ListItemText
            primary={
              <Typography>
                Return to this page to connect your new number to your WhatsApp
                account via Meta.
              </Typography>
            }
            sx={listItemStyle}
          />
        </ListItem>
      </List>

      <Typography mt={1}>
        Meta will then review and approve your request. This process can take
        10-14 business days. You will be notified once your WhatsApp account is
        ready for use.
      </Typography>

      <Typography mt={1}>
        If you need help,{' '}
        <Link
          href={getSupportUrl({ ticketForm: 'help_with_whatsapp_setup' })}
          target="_blank"
        >
          contact Popp's support team
        </Link>
      </Typography>

      <Box mt={4}>
        <Button
          endIcon={<LaunchIcon />}
          variant="primary"
          onClick={() =>
            window.open(
              META_BUSINESS_ACCOUNT_URL,
              '_blank',
              'noopener,noreferrer'
            )
          }
        >
          Create Meta business account
        </Button>
      </Box>
    </Box>
  );
};
